const currentLocal = "nl-NL";

const safeFormat = (value, formatFunction) => {
  return value == null || isNaN(value) ? "-" : formatFunction(value);
};

const formatEuro = (fraction, value) => safeFormat(value, (val) => 
  new Intl.NumberFormat(currentLocal, { 
    style: "currency", 
    currency: "EUR", 
    minimumFractionDigits: fraction,
    maximumFractionDigits: fraction 
  }).format(val)
);

const formatEuroNoFraction = (value) => formatEuro(0, value);

const formatThousand = (fraction, value) => safeFormat(value, (val) =>
  new Intl.NumberFormat(currentLocal, { 
    minimumFractionDigits: fraction, 
    maximumFractionDigits: fraction 
  }).format(val)
);

const formatThousandNoFraction = (value) => formatThousand(0, value);

const formatInt = (value) => safeFormat(value, (val) => val.toFixed(0));

export { formatEuro, formatEuroNoFraction, formatThousand, formatThousandNoFraction, formatInt };
